export default __webpack_public_path__ + "static/media/arts_right.bd4e1812.svg";